class NostoWelcomeBackBanner extends HTMLElement {
  constructor() {
    super();
    this.placementId = '';
    this.heading = '';
    this.content = '';
    this.ctaText = '';
    this.products = [];
  }

  static get observedAttributes() {
    return ['placement-id', 'heading', 'content', 'cta-text'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this[name.replace(/-([a-z])/g, (_, c) => c.toUpperCase())] = newValue;
    if (name !== 'placement-id') this.render();
  }

  connectedCallback() {
    this.init();
  }

  async init() {
    const response = await this.getOrWaitForNosto();
    if (!response || !response.recommendations) {
      console.warn("Nosto recommendations not available", { response, placement: this.placementId });
      return;
    }

    const recommendation = response.recommendations[this.placementId];
    this.products = recommendation?.products || [];
    this.render();
  }

  async getOrWaitForNosto() {
    let response = null;
    try {
      response = await window.__NOSTO_RECOMMENDER__.getRecommendation();
    } catch (error) {
      console.error(error);
    }

    return response;
  }

  _renderProductCards() {
    let html = '';
    for (let i = 0; i < 4; i++) {
      const product = this.products[i];
      if (!product) continue;

      html += `
        <li class="nosto-banner__product${i === 3 ? ' nosto-banner__product--desktop-only' : ''}">
          <a href="${product.url}" class="nosto-banner__product-link">
            <img src="${product.image_url}" class="nosto-banner__product-img" />
            <span class="nosto-banner__cta">${this.ctaText}</span>
          </a>
        </li>
      `;
    }
    return html;
  }

  render() {
    if (!this.products.length) {
      this.innerHTML = '';
      return;
    }

    this.innerHTML = `
      <section class="nosto-banner">
        <div class="nosto-banner__info">
          <h3 class="nosto-banner__heading">${this.heading}</h3>
          <p class="nosto-banner__content${this.content === '' ? ' nosto-banner__content--hidden' : ''}">${this.content}</p>
        </div>
        <ul class="nosto-banner__products">${this._renderProductCards()}</ul>
      </section>
    `;
  }
}

customElements.define('nosto-welcome-back-banner', NostoWelcomeBackBanner);
